// import { canUseDOM } from 'exenv';

export function personIndexSectionNextLoading(resp = {}, store = {}) {
  return {
    type: 'PERSON_INDEX_SECTION_NEXT_LOADING',
    personIndexSectionNext: resp,
    store
  };
}

export function personIndexSectionNextLoaded(resp = {}, store = {}) {
  return {
    type: 'PERSON_INDEX_SECTION_NEXT_LOADED',
    personIndexSectionNext: resp,
    store
  };
}

export function personIndexSectionNextLoadError(error, store = {}) {
  return {
    type: 'PERSON_INDEX_SECTION_NEXT_ERROR',
    personIndexSectionNext: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
